<script setup lang="ts">
export interface PhxsgSectionProps {
  spacing?: string | number | null;
  use?: keyof HTMLElementTagNameMap;
}

const { use = 'section' } = defineProps<PhxsgSectionProps>();
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-section',
      {
        [`phxsg-section--${spacing}`]: spacing,
      },
    ]"
  >
    <slot />
  </component>
</template>

<style src="./section.css" />
